import { render, staticRenderFns } from "./forgot-password.vue?vue&type=template&id=8bdbd248&scoped=true&"
import script from "./forgot-password.vue?vue&type=script&lang=ts&"
export * from "./forgot-password.vue?vue&type=script&lang=ts&"
import style0 from "./forgot-password.vue?vue&type=style&index=0&id=8bdbd248&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bdbd248",
  null
  
)

export default component.exports